<h2 mat-dialog-title>Send auger purge settings</h2>
<mat-dialog-content>
	<ul>
		<li *ngFor="let line of data.summaryLines">{{ line }}</li>
	</ul>
	<p>This changes the machine. The change is sent once. If the machine is offline, it is not applied until you send it again.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Cancel</button>
	<button mat-raised-button color="primary" type="button" (click)="onConfirm()">Send</button>
</mat-dialog-actions>
